import { applyDecorators, HttpCode, HttpStatus, Post, Type, UseInterceptors } from '@nestjs/common';
import {
  ApiBadRequestResponse,
  ApiConflictResponse,
  ApiConsumes,
  ApiCreatedResponse,
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiNotFoundResponse,
  ApiOkResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';
import { AutoReapInterceptor, FileInterceptor } from '../interceptors';

export const FileResponse = <T extends Type>(path: string | string[], multer: string, type?: T, roles?: string[], statusCode = HttpStatus.OK) =>
  applyDecorators(
    ApiBadRequestResponse({ description: 'Bad Request (400)' }),
    ApiConflictResponse({ description: 'Conflict (409)' }),
    ApiConsumes('multipart/form-data'),
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiNotFoundResponse({ description: 'Not Found (404)' }),
    statusCode === HttpStatus.OK ? ApiOkResponse({ description: 'OK (200)', type }) : ApiCreatedResponse({ description: 'Created (201)', type }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    HttpCode(statusCode),
    Post(path),
    Roles(roles),
    UseInterceptors(FileInterceptor(multer), AutoReapInterceptor)
  );
